import React, { useEffect, useState } from 'react';
import { confirmSignUp } from '@aws-amplify/auth';
import { StyledSnackbar } from '../common/AppSnackbar';
import { Navigate, useLocation } from 'react-router-dom';

function ConfirmUser() {
  const [state, setState] = useState({
    openError: false,
    openConfirm: false,
    verify: false,
    confirmMessage: '',
    errorMessage: '',
  });

  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const userName = params.get('user_name');
    const code = params.get('confirmation_code');

    const confirmUser = async () => {
      try {
        await confirmSignUp({ username: userName, confirmationCode: code });
        setState(prevState => ({
          ...prevState,
          confirmMessage: 'Your account has been verified',
          openConfirm: true,
        }));
      } catch (error) {
        console.error('Error confirming sign up:', error);
        setState(prevState => ({
          ...prevState,
          errorMessage: 'Error confirming your account',
          openError: true,
        }));
      }
    };

    if (userName && code) {
      confirmUser();
    }
  }, [location.search]);

  const handleClose = () => {
    const { openError, openConfirm } = state;
    if (openError) {
      setState(prevState => ({ ...prevState, openError: false, verify: true }));
    } else if (openConfirm) {
      setState(prevState => ({ ...prevState, openConfirm: false, verify: true }));
    }
  };

  const { errorMessage, openError, openConfirm, confirmMessage, verify } = state;

  if (verify) {
    return <Navigate to="/" />;
  }

  return (
    <div>
      <StyledSnackbar
        open={openError}
        message={errorMessage}
        severity="error"
        onClose={handleClose}
        autoHideDuration={6000}
      />
      <StyledSnackbar
        open={openConfirm}
        message={confirmMessage}
        severity="success"
        onClose={handleClose}
        autoHideDuration={6000}
      />
    </div>
  );
}

export default ConfirmUser;
